<template>
  <div
    :style="{
      '--primary-color': tenant ? tenant.primaryColor : '#fff',
      '--secondary-color': tenant ? tenant.secondaryColor : '#fff'
    }"
  >
    <router-view></router-view>
  </div>
</template>

<script>
  export default {}
</script>
